// extracted by mini-css-extract-plugin
export var calendarView = "_ma-0";